import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Toast extends PureComponent {
  closeToast = () => {
    const { toastKey, closeToasterFn } = this.props;
    if (closeToasterFn) {
      closeToasterFn(toastKey);
      clearTimeout(this.timer);
    }
  }

  componentDidMount = () => {
    const { dismissTimeoutMS } = this.props;
    if (dismissTimeoutMS) {
      this.timer = setTimeout(() => {
        this.closeToast();
      }, dismissTimeoutMS);
    }
  }

  render() {
    const {
      type, message, style, dismissTimeoutMS
    } = this.props;
    return (
      <div className={`generic-modal-toaster ${type}`} style={style}>
        <div className="generic-modal-toaster__body">{message}</div>
        <div className="generic-modal-toaster__close-button" onClick={this.closeToast} />
        {
          dismissTimeoutMS && <div className="generic-modal-toaster__countdown-bar" />
        }
      </div>
    );
  }
}

Toast.propTypes = {
  // required
  type: PropTypes.oneOf([
    'success', 'warning', 'error'
  ]).isRequired,
  toastKey: PropTypes.any.isRequired,
  message: PropTypes.string.isRequired,
  // optional
  closeToasterFn: PropTypes.func,
  dismissTimeoutMS: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any)
};

Toast.defaultProps = {
  style: {},
  closeToasterFn: null,
  dismissTimeoutMS: null
};

export default Toast;
